<template>
  <div class="app-container">
    <el-card shadow="never">
      <div slot="header" class="card-header">
        <span class="card-title">文件夹归属管理</span>
        <span class="card-desc">为一级文件夹分配归属用户，子文件夹自动继承归属</span>
      </div>

      <el-table
        v-loading="loading"
        :data="folderList"
        border
        stripe
        style="width: 100%"
      >
        <el-table-column label="文件夹名称" prop="folderName" min-width="160">
          <template slot-scope="{ row }">
            <i class="el-icon-folder" style="color: #e6a23c; margin-right: 6px;"></i>
            <span>{{ row.folderName }}</span>
          </template>
        </el-table-column>

        <el-table-column label="当前归属用户" min-width="180">
          <template slot-scope="{ row }">
            <el-tag v-if="row.ownerUserId" type="success" size="small">
              {{ row.ownerNickname || row.ownerUsername }}
              <span v-if="row.ownerNickname && row.ownerUsername" style="color: #999; margin-left: 4px;">
                ({{ row.ownerUsername }})
              </span>
            </el-tag>
            <span v-else style="color: #999; font-size: 13px;">— 未归属</span>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="320" align="center">
          <template slot-scope="{ row }">
            <div style="display: flex; align-items: center; justify-content: center; gap: 8px; flex-wrap: nowrap;">
              <el-select
                v-model="row._editOwnerId"
                placeholder="选择归属用户"
                clearable
                filterable
                size="small"
                style="width: 180px;"
                :loading="userLoading"
              >
                <el-option
                  v-for="user in userList"
                  :key="user.id"
                  :label="(user.nickname || user.username) + ' (' + user.username + ')'"
                  :value="user.id"
                />
              </el-select>
              <el-button
                type="primary"
                size="small"
                class="btn-save-owner"
                :loading="row._saving"
                @click="handleSave(row)"
              >保存</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import { listFolderOwnership, setFolderOwner, listOwnerUsers } from '@/api/material/folder';

export default {
  name: 'FolderOwnership',
  data() {
    return {
      loading: false,
      userLoading: false,
      folderList: [],
      userList: []
    };
  },
  created() {
    this.fetchData();
    this.fetchUsers();
  },
  methods: {
    async fetchData() {
      this.loading = true;
      try {
        const res = await listFolderOwnership();
        const list = res.data || [];
        // 为每行附加编辑用的临时字段
        this.folderList = list.map(item => ({
          ...item,
          _editOwnerId: item.ownerUserId || null,
          _saving: false
        }));
      } catch (e) {
        this.$message.error('加载文件夹归属数据失败');
      } finally {
        this.loading = false;
      }
    },
    async fetchUsers() {
      this.userLoading = true;
      try {
        const res = await listOwnerUsers();
        this.userList = res.data || [];
      } catch (e) {
        this.$message.error('加载用户列表失败');
      } finally {
        this.userLoading = false;
      }
    },
    async handleSave(row) {
      row._saving = true;
      try {
        await setFolderOwner(row.folderId, row._editOwnerId || null);
        // 更新本地展示字段
        row.ownerUserId = row._editOwnerId || null;
        if (row.ownerUserId) {
          const user = this.userList.find(u => u.id === row.ownerUserId);
          row.ownerNickname = user ? user.nickname : null;
          row.ownerUsername = user ? user.username : null;
        } else {
          row.ownerNickname = null;
          row.ownerUsername = null;
        }
        this.$message.success('归属设置成功');
      } catch (e) {
        this.$message.error('设置失败，请重试');
      } finally {
        row._saving = false;
      }
    }
  }
};
</script>

<style scoped>
.card-header {
  display: flex;
  align-items: center;
  gap: 12px;
}
.card-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}
.card-desc {
  font-size: 13px;
  color: #909399;
}

/* 覆盖 global.css 对表格内按钮的透明化处理，恢复保存按钮的正常样式 */
::v-deep .el-table .cell .btn-save-owner.el-button--primary {
  background: linear-gradient(145deg, #409EFF, #3a8ee6) !important;
  border: none !important;
  box-shadow: 0 4px 10px rgba(64, 158, 255, 0.3) !important;
  color: #fff !important;
  padding: 7px 14px !important;
}
::v-deep .el-table .cell .btn-save-owner.el-button--primary:hover {
  background: linear-gradient(145deg, #66b1ff, #409EFF) !important;
  box-shadow: 0 6px 15px rgba(64, 158, 255, 0.4) !important;
}
</style>
